import { html, LitElement } from 'lit';

export default class InformationWebComponent extends LitElement {
  createRenderRoot() {
    return this;
  }

  static properties = {
    name: { type: String },
    data: { type: Object }
  };

  constructor() {
    super();
    this.name = 'Information Web Component';
    this.data = {};
  }

  async connectedCallback() {
    super.connectedCallback();

    // console.log(this.data, 'BUENAS BUENAS');
  }

  render() {
    const { data } = this;

    const { descriptionhome, titlehome } = data;

    return html`
      <section class="information-component">
        <h1 aria-label="Title of the promotion">${titlehome || 'Promotion Title'}</h1>
        ${descriptionhome[0].children[0].text !== ''
    ? descriptionhome.map(
      (item) =>
        html`<p aria-label="Description of the promotion">
                  ${item.children?.[0]?.text || ''}
                </p>`
    )
    : html`<p>
              Wafer sweet apple pie gummi bears muffin. Pie cookie brownie marzipan candy gummi
              bears. Cupcake gingerbread cake liquorice pudding apple pie sesame snaps.
              <br />
              <br />
              Macaroon marzipan tart danish tiramisu tootsie roll donut cupcake fruitcake. Caramels
              sweet lemon drops brownie pastry cookie bonbon jujubes topping.
            </p>`}
      </section>
    `;
  }
}

customElements.define('information-webcomponent', InformationWebComponent);
